import React from 'react'
import 'animate.css'

import dynamic from 'next/dynamic'

const MainLayout = dynamic(() => import('@/layouts/MainLayout'), {
  ssr: true,
})

const IntroAbout = dynamic(() => import('@/components/about/intro/IntroAbout'), {
  ssr: true,
})
const ZShapeAbout = dynamic(() => import('@/components/about/zShape/ZShapeAbout'), {
  ssr: true,
})
const InfoBoxes = dynamic(() => import('@/components/about/infoBoxes/InfoBoxes'), {
  ssr: true,
})
const BoardAbout = dynamic(() => import('@/components/about/board/BoardAbout'), {
  ssr: true,
})
const NumbersAbout = dynamic(() => import('@/components/about/numbers/NumbersAbout'), {
  ssr: false,
})

const ContactAbout = dynamic(() => import('@/components/about/contact/ContactAbout'), {
  ssr: true,
})
const AutoSlider = dynamic(() => import('@/components/home/partnerSliders/AutoSlider'), { ssr: true })

/** TODO: delete this about us page, once storyblock version one is published
 * Also delete the corresponding components that are not used in storyblock
 **/
export default function About() {
  return (
    <MainLayout
      title="About | Cellect Energy"
      description="Our platform offers a universal solution for energy storage asset managers, providing a standard API for remote control which eliminates integration needs."
      navbarTheme="dark"
    >
      <IntroAbout />
      <ZShapeAbout />
      <InfoBoxes />
      <BoardAbout />
      <NumbersAbout />
      <AutoSlider />
      <ContactAbout />
    </MainLayout>
  )
}
